import { render, staticRenderFns } from "./form-switch-item.vue?vue&type=template&id=6a6555f7"
import script from "./form-switch-item.vue?vue&type=script&lang=js"
export * from "./form-switch-item.vue?vue&type=script&lang=js"
import style0 from "./form-switch-item.vue?vue&type=style&index=0&id=6a6555f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports